import { motion } from "framer-motion";
import { usePublicData } from "../../context/PublicDataContext";
import { getIcon } from "../../lib/icons";

export const WhyChoose = () => {
  const { content } = usePublicData();
  const features = content.features;
  return (
    <section id="why" className="relative py-24 md:py-32" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="text-sm font-semibold text-[#0033FF] uppercase tracking-widest mb-3"
            >
              Why QuickDrop Go
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="font-display font-extrabold tracking-tighter text-4xl md:text-5xl text-[#0b1221] sticky top-28"
            >
              Built for speed.
              <br />
              Designed for trust.
            </motion.h2>
          </div>

          <div className="lg:col-span-8 space-y-4">
            {features.map((f, i) => {
              const Icon = getIcon(f.iconName);
              return (
                <motion.div
                  key={f.n}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.05 }}
                  className="group flex items-start gap-6 rounded-2xl bg-white border border-[#0033FF]/8 p-7 hover:border-[#0033FF]/25 hover:shadow-[0_18px_44px_rgba(0,51,255,0.1)] transition-[border-color,box-shadow] duration-300"
                  data-testid={`feature-card-${i}`}
                >
                  <span className="font-display font-extrabold text-3xl text-[#0033FF]/20 group-hover:text-[#0033FF] transition-colors duration-300 w-16 shrink-0">
                    {f.n}
                  </span>
                  <span className="w-12 h-12 rounded-xl bg-[#0033FF]/8 text-[#0033FF] flex items-center justify-center shrink-0 group-hover:bg-[#0033FF] group-hover:text-white transition-colors duration-300">
                    <Icon className="w-6 h-6" />
                  </span>
                  <div>
                    <h3 className="font-display font-bold text-xl text-[#0b1221] mb-1.5">
                      {f.title}
                    </h3>
                    <p className="text-[#5e6c84] leading-relaxed">{f.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
